import type { ReactNode } from 'react'

import { MarketingButton } from '@/components/ui/marketing-button'

/**
 * Legacy rendered these CTAs as Blueprint <Button>s with NO href and NO onClick — controls that
 * did nothing when pressed. Every button therefore takes a REQUIRED href here: a dead control is
 * exactly the "looks like it works but doesn't" shape this port must not reproduce, and the
 * talent app has real destinations for each label (see docs/features/landing-coverage.md).
 * Employer CTAs keep the marketing (cyan) style, talent CTAs the primary pill — as legacy.
 */
export function FeaturedItem({
  title,
  subtitle = '',
  description,
  imgSrc,
  buttonText,
  buttonHref,
  reverse = false,
  isEmployer = false,
  children,
}: {
  title: string
  subtitle?: string
  description: string
  imgSrc: string
  buttonText?: string
  buttonHref?: string
  reverse?: boolean
  isEmployer?: boolean
  children?: ReactNode
}) {
  return (
    <div className={`featured-item${reverse ? ' reverse' : ''}${isEmployer ? ' isEmployer' : ''}`}>
      <div className="featured-item-content">
        <h3>{title}</h3>
        {subtitle && <h6>{subtitle}</h6>}
        <p>{description}</p>

        {children}

        {buttonText && buttonHref && (
          <div className="featured-item-action">
            {isEmployer ? (
              <MarketingButton href={buttonHref}>{buttonText}</MarketingButton>
            ) : (
              <a className="btn-primary" href={buttonHref}>
                {buttonText}
              </a>
            )}
          </div>
        )}
      </div>

      <div className="featured-item-image">
        <img src={imgSrc} alt="" />
      </div>
    </div>
  )
}
